import { render, staticRenderFns } from "./booking_success.vue?vue&type=template&id=00bd38ec&scoped=true&"
import script from "./booking_success.vue?vue&type=script&lang=js&"
export * from "./booking_success.vue?vue&type=script&lang=js&"
import style0 from "./booking_success.vue?vue&type=style&index=0&id=00bd38ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd38ec",
  null
  
)

export default component.exports